import ModalForm from 'components/commons/modal-form'
import { capitalize } from 'utils/utils'
import { InlineError, Input, Switch } from 'avo-ui'

export const FormSettingPointCollection = ({
    show,
    onHideForm,
    dataPointCollection,
    isLoading,
    onChangeForm,
    errorForm,
    onSubmit,
}) => {
    return (
        <ModalForm
            className={'!w-[450px]'}
            classNameContent={'!max-h-[500px] overflow-auto'}
            show={show}
            onHide={onHideForm}
            title={`Update ${capitalize(dataPointCollection?.name?.replace('-', ' '))}`}
            isLoading={isLoading}
            onSubmit={onSubmit}
        >
            <div className={'flex flex-col space-y-6 px-8 py-2 mb-2'}>
                <div className={'flex flex-col space-y-3'}>
                    <div className={'font-semibold text-blue-90 required'}>
                        {dataPointCollection?.name === 'order-completed'
                            ? 'Nilai Point per kelipatan transaksi'
                            : 'Nilai Point'}
                    </div>
                    <Input
                        type={'number'}
                        className={'flex-1'}
                        name={'total_point'}
                        placeholder={'Masukkan nilai point'}
                        value={dataPointCollection?.total_point}
                        onChange={onChangeForm}
                    />
                    <InlineError className='mt-2' message={errorForm?.total_point} />
                </div>
                {dataPointCollection?.name === 'order-completed' && (
                    <>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90 required'}>
                                Minimal transaksi (kelipatan minimal)
                            </div>
                            <Input
                                addonBefore={'Rp'}
                                type={'currency'}
                                className={'flex-1'}
                                name={'min_transaction'}
                                placeholder={'Masukkan minimal order'}
                                value={dataPointCollection?.min_transaction}
                                onChange={onChangeForm}
                            />
                            <InlineError className='mt-2' message={errorForm?.min_transaction} />
                        </div>
                        <div className={'flex flex-col space-y-3'}>
                            <div className={'font-semibold text-blue-90 required'}>Max. Point Per Order</div>
                            <Input
                                type={'number'}
                                className={'flex-1'}
                                name={'max_amount'}
                                placeholder={'Masukkan maximal point per order'}
                                value={dataPointCollection?.max_amount}
                                onChange={onChangeForm}
                            />
                            <InlineError className='mt-2' message={errorForm?.max_amount} />
                        </div>
                    </>
                )}
                <div className={'flex flex-col space-y-3'}>
                    <div className={'flex items-center space-x-2'}>
                        <Switch name={'is_active'} checked={!!dataPointCollection?.is_active} onChange={onChangeForm} />
                        <p className={'font-semibold'}>{!dataPointCollection?.is_active ? 'Inactive' : 'Active'}</p>
                    </div>
                    <InlineError className='mt-2' message={errorForm?.is_active} />
                </div>
            </div>
        </ModalForm>
    )
}
